import type { ExperimentName } from 'frontend/shared/javascripts/modules/ab_tests'

export type HiddenField = 'userId' | 'page' | 'loginState' | 'device' | 'trafficSource'

export interface SurveyQuestion {
  entry: string
  title: string
  options: readonly string[]
}

export interface SurveyForm {
  // Remembers who has seen the survey. A new form needs a new id to reach everyone again.
  id: string
  // Shown to variant b of this experiment, so several surveys can run side by side.
  experiment: Extract<ExperimentName, `survey_${string}`>
  responseUrl: string
  questions: readonly SurveyQuestion[]
  hiddenFields: Readonly<Record<HiddenField, string>>
}

// Entry ids are listed in FB_PUBLIC_LOAD_DATA_ on the form's public viewform page.
// Option texts must match the form character for character: Google stores whatever we send.
export const learningIntentForm: SurveyForm = {
  id: 'learning-intent',
  experiment: 'survey_learning_intent',
  responseUrl:
    'https://docs.google.com/forms/d/e/1FAIpQLSf-51ZROEC9x1GYstnc7XToU3yNH9HIEuKgl247RBcmic6VlQ/formResponse',
  questions: [
    {
      entry: 'entry.2102759603',
      title: 'Was steht bei dir gerade an?',
      options: [
        'Üben oder Wissen testen',
        'Hausaufgaben oder Aufgabe lösen',
        'Referat, Präsentation oder mündliche Prüfung vorbereiten',
        'Für eine Prüfung oder Test lernen',
        'Stoff wiederholen / festigen',
        'Schnell etwas nachschauen',
        'Ein Thema verstehen',
      ],
    },
    {
      entry: 'entry.294739081',
      title: 'Zu welcher Gruppe gehörst du?',
      options: ['Studierende', 'Azubis', 'Lehrkraft', 'Schüler:innen'],
    },
  ],
  hiddenFields: {
    userId: 'entry.1162145475',
    page: 'entry.1168683030',
    loginState: 'entry.959112614',
    device: 'entry.1963479739',
    trafficSource: 'entry.511841433',
  },
}
